import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Context } from 'Context/Context';
import { updateUserApi, DEFAULT_STATE } from 'Constants';
import { getCaseType } from 'Utils';
import { ProfileCard } from './ProfileDetailsView';
import CasePrefPicker from './CasePrefPicker';

// Law firm profile: the case types the firm takes. Optional, editable any time,
// saved straight to the account (no admin review). Also the firm's default
// case filter and what the client pre-approve list matches on.
function FirmCasePrefCard() {
  const { userDetails, makeApiCallFunc, setUpdateLoggedinData } = useContext(Context);
  const saved = Array.isArray(userDetails?.casePref) ? userDetails.casePref : [];
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(saved);
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (!editing) setDraft(saved); }, [userDetails?.casePref]); // eslint-disable-line react-hooks/exhaustive-deps

  const save = () => {
    setBusy(true);
    makeApiCallFunc(updateUserApi, { user: userDetails._id, casePref: draft, statePref: [DEFAULT_STATE] },
      () => {
        setBusy(false); setEditing(false);
        setUpdateLoggedinData && setUpdateLoggedinData((p) => !p);
        toast.success('Case preferences saved.');
      },
      (e) => { setBusy(false); console.log(e); toast.error('Could not save your case preferences.'); });
  };

  return (
    <ProfileCard title='Case preferences' note='Optional. Used as your default case filter and to show your firm to clients with matching cases.'>
      <div className='py-3 lg:py-4'>
        {editing ? (
          <>
            <CasePrefPicker value={draft} onChange={setDraft} label='Case types your firm takes' />
            <div className='flex gap-2 mt-4'>
              <button type='button' onClick={save} disabled={busy}
                className='font-plexsans font-semibold text-[13px] leading-none text-ivory bg-brass hover:bg-brassDark rounded-md py-2.5 px-4 cursor-pointer disabled:opacity-60'>
                {busy ? 'Saving…' : 'Save'}
              </button>
              <button type='button' onClick={() => { setDraft(saved); setEditing(false); }} disabled={busy}
                className='font-plexsans font-semibold text-[13px] leading-none text-navy bg-white border border-navy/[.2] rounded-md py-2.5 px-4 cursor-pointer'>
                Cancel
              </button>
            </div>
          </>
        ) : (
          <div className='flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3'>
            <div className='flex flex-wrap gap-2'>
              {saved.length === 0
                ? <span className='font-plexsans text-[13.5px] text-navy/[.65]'>All case types</span>
                : saved.map((id) => (
                    <span key={id} className='font-plexsans text-[12.5px] leading-none text-navy bg-navy/[.05] border border-navy/[.12] rounded-full py-[7px] px-3'>{getCaseType(id)}</span>
                  ))}
            </div>
            <button type='button' onClick={() => setEditing(true)}
              className='flex-none self-start font-plexsans font-semibold text-[13px] leading-none text-brass bg-white border border-brass/[.4] hover:bg-brass/[.06] rounded-md py-2.5 px-4 cursor-pointer'>
              Edit
            </button>
          </div>
        )}
      </div>
    </ProfileCard>
  );
}

export default FirmCasePrefCard;
